import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const WHATSAPP_URL = 'https://wa.me/13478886047';
export function FloatingWhatsApp() {
  const shouldReduceMotion = useReducedMotion();
  return <motion.a href={WHATSAPP_URL} target="_blank" rel="noreferrer" aria-label="Escríbenos por WhatsApp" initial={{
    opacity: 0,
    scale: 0.86
  }} animate={shouldReduceMotion ? {
    opacity: 1,
    scale: 1
  } : {
    opacity: 1,
    scale: 1,
    y: [0, -5, 0]
  }} transition={shouldReduceMotion ? {
    duration: 0.16,
    ease: [0.22, 1, 0.36, 1]
  } : {
    opacity: {
      duration: 0.24,
      ease: [0.22, 1, 0.36, 1]
    },
    scale: {
      duration: 0.24,
      ease: [0.22, 1, 0.36, 1]
    },
    y: {
      duration: 3.2,
      ease: 'easeInOut',
      repeat: Infinity
    }
  }} whileHover={shouldReduceMotion ? undefined : {
    scale: 1.06,
    y: -3
  }} whileTap={{
    scale: 0.94
  }} className="group fixed bottom-5 right-5 z-40 flex h-16 w-16 items-center justify-center rounded-full border border-metallic-border bg-[#f8f2e8] p-1.5 shadow-[0_12px_28px_rgba(74,55,35,0.24)] outline-none focus-visible:ring-2 focus-visible:ring-champagne focus-visible:ring-offset-4 focus-visible:ring-offset-warm-white sm:bottom-7 sm:right-7 sm:h-[4.5rem] sm:w-[4.5rem]" data-id="element-120" data-mp="1e5v05v6k8i7">
      <span aria-hidden="true" className="absolute -inset-1 rounded-full border border-metallic-border/70" data-id="element-121" data-mp="3jhmamidwj08k" />
      <motion.span aria-hidden="true" animate={shouldReduceMotion ? {
      scale: 1,
      opacity: 1
    } : {
      scale: [1, 1.045, 1],
      opacity: [0.94, 1, 0.94]
    }} transition={shouldReduceMotion ? {
      duration: 0.16
    } : {
      duration: 2.4,
      ease: 'easeInOut',
      repeat: Infinity
    }} className="metallic-gold-surface relative flex h-full w-full items-center justify-center rounded-full text-white shadow-[inset_0_1px_0_rgba(255,250,229,0.48),0_4px_10px_rgba(131,100,47,0.28)]" data-id="element-122" data-mp="b1j0m5zbgzh2">
        <WhatsAppGlyph data-id="element-123" data-mp="2rqeu9xdypkkk" />
      </motion.span>
    </motion.a>;
}
function WhatsAppGlyph() {
  return <svg viewBox="0 0 24 24" aria-hidden="true" className="h-8 w-8 fill-current sm:h-9 sm:w-9" data-id="element-124" data-mp="x8wwle9zxtu6">
      <path d="M12.04 2C6.58 2 2.15 6.43 2.15 11.89c0 1.75.46 3.39 1.26 4.82L2 22l5.43-1.38c1.38.76 2.96 1.16 4.61 1.16h.01c5.46 0 9.89-4.43 9.89-9.89S17.5 2 12.04 2Zm5.76 13.98c-.24.67-1.4 1.28-1.93 1.36-.5.08-1.14.11-1.83-.11-.42-.13-.95-.31-1.64-.61-2.88-1.24-4.76-4.14-4.9-4.33-.14-.19-1.17-1.56-1.17-2.98s.74-2.12 1-2.41c.26-.28.57-.35.76-.35h.55c.18.01.42-.07.66.5.24.57.81 1.98.88 2.12.07.14.12.31.02.5-.1.19-.15.31-.3.48-.15.17-.31.38-.44.51-.15.15-.3.31-.13.61.17.29.75 1.24 1.61 2.01 1.11.99 2.04 1.3 2.33 1.45.29.14.46.12.63-.07.18-.19.72-.84.91-1.13.19-.29.38-.24.64-.14.26.09 1.67.79 1.96.93.29.14.48.21.55.33.07.12.07.7-.17 1.37Z" data-id="element-125" data-mp="saveavke9yjr" />
    </svg>;
}